<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex trainer-form__shell">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap trainer-form__grid">
          <div class="w-full md:w-1/2 px-3 mb-6">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Trainer's Prefix</label
            >
            <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
            <v-select
                v-model="formValues.prefix"
                :elevation="1"
                :items="prefixes"
                dense
                item-text="name"
                item-value="name"
                label="trainer's prefix"
                solo
            ></v-select>

            <!-- <span class="text-gray-600 text-xs italic text-red-700">{{
              errors[0]
            }}</span>
          </validation-provider> -->
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Trainer Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="trainername"
                  v-model="formValues.trainerName"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="trainerName"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Trainer's Father Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="trainerFathername"
                  v-model="formValues.trainerFatherName"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="trainerFatherName"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Trainer's Grandfather Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="trainerGrandfathername"
                  v-model="formValues.trainerGrandfatherName"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="trainerGrandFatherName"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Gender</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <div class="trainer-form__radio-group">
                <label class="trainer-form__radio" for="Male">
                  <input
                      id="Male"
                      v-model="formValues.gender"
                      class="trainer-form__radio-input"
                      type="radio"
                      value="Male"
                  />
                  Male
                </label>
                <label class="trainer-form__radio" for="Female">
                  <input
                      id="Female"
                      v-model="formValues.gender"
                      class="trainer-form__radio-input"
                      type="radio"
                      value="Female"
                  />
                  Female
                </label>
              </div>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Phone Number</label
            >
            <validation-provider
                v-slot="{ errors }"
                :mode="'eager'"
                :rules="{
                required: true,
                phone_regex: '^\\+251[97]\\d{8}$',
              }"
            >
              <input
                  id="phoneNumber"
                  v-model="formValues.phoneNumber"
                  inputmode="numeric"
                  maxlength="13"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="+2519xxxxxxx"
                  type="tel"
                  @input="onPhoneInput('phoneNumber', $event.target.value, true)"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Email Address</label
            >
            <validation-provider v-slot="{ errors }" rules="required|email">
              <input
                  id="emailAdress"
                  v-model="formValues.email"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="emailAdress"
                  type="email"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Educational Level</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.educationalLevelId"
                  :clearable="clearable"
                  :elevation="1"
                  :items="EDUCATIONAL_LEVLES"
                  :loading="eduLevelLoading"
                  :searchable="searchable"
                  dense
                  item-text="name"
                  item-value="id"
                  label="education levels"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Profession</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.professionId"
                  :clearable="clearable"
                  :elevation="1"
                  :items="PROFESSIONS"
                  :loading="professionLoading"
                  :searchable="searchable"
                  dense
                  item-text="name"
                  item-value="id"
                  label="health professions"
                  solo
                  @change="professionOnChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="showOtherName"
              class="w-full md:w-1/2 px-3 mb-6 required"
          >
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Other Profession Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="otherProfessionName"
                  v-model="formValues.otherProfessionName"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="otherProfessionName"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Trainer Type</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.trainerTypeId"
                  :clearable="clearable"
                  :elevation="1"
                  :items="TRAINER_TYPES"
                  :loading="trainerTypesLoading"
                  :searchable="searchable"
                  dense
                  item-text="name"
                  item-value="id"
                  label="trainer types"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Trainer Selection Criteria</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.trainerSelectionCriteriaId"
                  :clearable="clearable"
                  :elevation="1"
                  :items="TRAINER_SELECTION_CRITERIAS"
                  :loading="trainerSelCritLoading"
                  :searchable="searchable"
                  dense
                  item-text="name"
                  item-value="id"
                  label="trainer selection criterias"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
        </div>
        <div class="flex flex-wrap trainer-form__actions">
          <div class="w-full">
            <button
                class="trainer-form__submit"
                type="button"
                @click="submit()"
            >
              {{ formValues.editMode ? "Update Trainer" : "Add Trainer" }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {
  getEducationalLevel,
  getHealthProfessions,
  getTrainerSelectionCriteriaList,
  getTrainerTypes,
} from "@/utils/helper";
import {PrefixEnum} from "@/utils/enums";
import {normalizeEthiopianPhone} from "@/utils/phone";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {email, min_value, regex, required} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("min_value", {
  ...min_value,
  message: "Invalid Value",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});
extend("phone_regex", {
  ...regex,
  message: "Use +251 then 9 or 7 and 8 digits (e.g. +2519xxxxxxx).",
});
export default {
  props: {
    trainer: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        trainerName: null,
        trainerFatherName: null,
        trainerGrandfatherName: null,
        gender: null,
        educationalLevelId: null,
        phoneNumber: null,
        email: null,
        professionId: null,
        trainerTypeId: null,
        trainerSelectionCriteriaId: null,
        otherProfessionName: null,
        prefix: "",
        editMode: false,
      },
      showProgress: false,
      PROFESSIONS: [],
      EDUCATIONAL_LEVLES: [],
      OPTIONS: [{name: "Female"}, {name: "Male"}],
      TRAINER_TYPES: [],
      TRAINER_SELECTION_CRITERIAS: [],
      showOtherName: false,
      searchable: true,
      clearable: true,
      eduLevelLoading: false,
      professionLoading: false,
      trainerTypesLoading: false,
      trainerSelCritLoading: false,
      prefixes: [],
    };
  },
  async created() {
    await this.initLookups();
    if (this.trainer != null) {
      this.formValues = this.trainer;
      this.formValues.editMode = true;
      this.formValues.phoneNumber = normalizeEthiopianPhone(this.formValues.phoneNumber, {forcePrefix: true});
    } else {
      this.formValues.phoneNumber = normalizeEthiopianPhone(this.formValues.phoneNumber, {forcePrefix: true});
    }
  },
  methods: {
    onPhoneInput(field, value, forcePrefix = false) {
      const normalized = normalizeEthiopianPhone(value, {forcePrefix});
      if (normalized !== this.formValues[field]) {
        this.formValues[field] = normalized;
      }
    },
    async initLookups() {
      this.prefixes = await PrefixEnum;
      this.eduLevelLoading = true;
      this.professionLoading = true;
      this.trainerTypesLoading = true;
      this.trainerSelCritLoading = true;
      this.TRAINER_TYPES = await getTrainerTypes();
      this.trainerTypesLoading = false;
      const healthProfs = await getHealthProfessions();
      this.PROFESSIONS = healthProfs.rows.filter((data) => {
        return data.isActive == true;
      });
      this.professionLoading = false;
      this.EDUCATIONAL_LEVLES = await getEducationalLevel();
      this.eduLevelLoading = false;
      const trainerSelectionCriteria = await getTrainerSelectionCriteriaList();
      this.TRAINER_SELECTION_CRITERIAS = trainerSelectionCriteria.rows.filter(
          (data) => {
            return data.isActive == true;
          }
      );
      this.trainerSelCritLoading = false;
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateTrainer", this.formValues);
    },
    professionOnChange(value) {
      const professionCopy = [...this.PROFESSIONS];
      const selectedId = value ? value : null;
      const filteredProfession = professionCopy.filter((data) => {
        return selectedId ? selectedId == data.id : null;
      })[0];

      if (filteredProfession && filteredProfession.code == "OTH") {
        this.showOtherName = true;
      } else {
        this.showOtherName = false;
      }
    },
  },
};
</script>

<style scoped>
.trainer-form__shell {
  padding: 12px;
}

.trainer-form__grid {
  margin: 12px 16px 6px;
  row-gap: 12px;
}

.trainer-form__grid > div {
  margin-bottom: 0 !important;
}

.trainer-form__grid br {
  display: none;
}

.trainer-form__actions {
  margin: 8px 16px 16px;
  justify-content: flex-end;
}

.trainer-form__actions .w-full {
  display: flex;
  justify-content: flex-end;
}

.trainer-form__submit {
  background: #1976d2;
  border: 1px solid #1976d2;
  color: #ffffff;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 6px;
}

.trainer-form__submit:hover {
  background: #1565c0;
  border-color: #1565c0;
}

.trainer-form__radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.trainer-form__radio {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #1f2937;
}

.trainer-form__radio-input {
  margin: 0;
}

.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
